import React from 'react';
import { Route, Switch } from 'react-router-dom';
import List from './List.jsx';
import Form from './Form.jsx';

const HomeSliderRoutes = ({ match }) => {
  return (
    <Switch>
      <Route path={`${match.url}/`} exact component={List} />
      <Route path={`${match.url}/add`} exact component={Form} />
    </Switch>
  );
};

export default HomeSliderRoutes;
